import { Input } from '@angular/core';
import { Model } from '@df/catalog/model';
import { FilterComponentDef } from '@df/catalog-ui/listing/filter/filter.component.def';
import { FilterAttributeOption } from '@df/catalog-ui/listing/filter/filter-attribute-option';
import { Directive } from '@angular/core';
@Directive()
export class FilterAttributeOptionComponentDef<T extends Model> extends FilterComponentDef<T> {
    /**
     * Filter model binding
     */
    @Input({
        required: true
    })
    override filter!: FilterAttributeOption<T>;
}
